/*
  import { zIndexes } from '@/utilities/zIndexes'
*/

export const zIndexes = {
  modals: 400,
  topNav: 200
}
